import { createRouter, RouterProvider } from '@tanstack/react-router';

import { AppProviders } from '@/app/providers/app-providers';
import { useSession } from './app/providers/session-provider';
import { routeTree } from './routeTree.gen';
import { QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient();
const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  scrollRestoration: true,
  context: {
    auth: undefined!,
    queryClient,
  },
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const AppRouterHost = () => {
  const auth = useSession();

  return (
    <RouterProvider
      router={router}
      context={{
        auth,
        queryClient,
      }}
    />
  );
};

export const App = () => (
  <AppProviders>
    <AppRouterHost />
  </AppProviders>
);
